export function buildParams<T extends string | boolean | number | undefined>(
  params: Record<string, T>
) {
  const filtered = Object.fromEntries(
    Object.entries(params)
      .filter(([_, v]) => v !== undefined && v !== '')
      .map(([k, v]) => [k, String(v)])
  )
  return new URLSearchParams(filtered).toString()
}
